import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import { translate } from 'react-i18next'
import { Metrics } from '../../Themes'
import Modal from '../../components/Modal'
import Pangea from '../../svg-icons/Pangea'

const Container = styled.div``

const CustomLogo = styled(Pangea)`
  width: ${Metrics.components.adminLogoSize};
  height: ${Metrics.components.adminLogoSize};
`

class AboutPangaea extends Component {
  render () {
    const { t, router } = this.props
    return (
      <Modal
        visible
        header={t('About Pangaea')}
        closeAction={() => {
          router.replace('/landing')
        }}>
        <Container>
          <CustomLogo />
          <p>
            {t(`Pangaea is an exclusive real estate investment platform for
            high-end, off-market assets. Access to Pangea is reserved for
            approved investors only. Pangea features hundreds of off-market
            properties worldwide, with a core focus on the DACH region and
            Europe.`)}
          </p>
        </Container>
      </Modal>
    )
  }
}

AboutPangaea.propTypes = {
  router: PropTypes.object,
  errorMessage: PropTypes.string,
  t: PropTypes.func,
  location: PropTypes.object
}

export default translate([ 'common', 'landing' ], { wait: true })(AboutPangaea)



// WEBPACK FOOTER //
// ./src/pages/Landing/AboutPangaea.js